import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Seller } from '../../types/seller';

export const useGetSellerEligibility = (seller: Seller) => {
    const {
        seller: { isPro, isAgency, sellerHourlyEligibility },
    } = useGigPageContext();

    const hasHourlyRate = !!seller.hourlyRate;
    if (!hasHourlyRate) return false;
    if (sellerHourlyEligibility !== undefined) {
        return sellerHourlyEligibility;
    }

    return !!isPro || isAgency;
};
